import {
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  Button,
  Form,
  CardBody,
  Table,
  FormCheck,
  Alert,
  CardFooter,
  Breadcrumb,
  InputGroup,
  Tabs,
  Tab,
} from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { FaTrash, FaPen, FaPlus } from 'react-icons/fa';
import { Modal } from "react-bootstrap";
import useCheckAuthorization from "../../hooks/checkAuthorization";
import Loader from "../common/Loader";
import Base from "../Base";
import ChatPopup from "../common/ChatPopup";
import toast from "react-hot-toast";

import {
  PAGE_PERMISSIONS,
  CRUD_PERMISSIONS,
  RESTRICT_ASSIGN_ROLES,
} from "../../constants/user";
import {
  createLitigation,
  updateLitigation,
  deleteLitigation,
  getLitigation,
  resetLitigationState,
} from "../../slices/litigationReducer";
import AddLitigation from "./AddLitigation";
import {
  LITIGATION_CREATION_FIELDS,
  LITIGATION_CREATION_SCHEMA,
} from "../../constants/litigations";
import PaginationComponent from "../common/Pagination";
import { truncateText } from "../../utils";
import { extractErrorMessage } from "../../constants/common";

export default function LitigationComponent() {
  const [showAddLitigationModal, setShowAddLitigationModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [isUpdate, setIsUpdate] = useState(false);
  const [current_page, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedLitigationId, setSelectedLitigationId] = useState(null);

  const [selectedLitigation, setSelectedLitigation] = useState(null);
  const searchRef = useRef();
  const { client_id } = useParams();
  const { litigationData, total_count, loading, error, success, successMsg } =
    useSelector((state) => state.litigation);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleAddLitigationShow = () => {
    setIsUpdate(false);
    setErrors({});
    setSelectedLitigation(null);
    setShowAddLitigationModal(true);
  };
  const handleAddLitigationClose = () => setShowAddLitigationModal(false);
  const hasPermission = useCheckAuthorization(PAGE_PERMISSIONS.user);
  const addPermission = useCheckAuthorization(CRUD_PERMISSIONS.user.add);
  const handleSubmit = async (e, isUpdate, id) => {
    e.preventDefault();
    const values = {};
    if (isUpdate) {
      values["lit_id"] = id;
    }
    Array.from(e.target.elements).forEach((inputElement) => {
      if (inputElement.type === "text") {
        values[inputElement.name] = inputElement.value;
      }
    });
    try {
      const data = await LITIGATION_CREATION_SCHEMA.validate(values, {
        abortEarly: false,
      });

      if (!isUpdate) {
        await dispatch(createLitigation({ clientId: client_id, data })).unwrap();
        toast.success("Litigation created successfully!");
      } else {
        await dispatch(updateLitigation({ clientId: client_id, data })).unwrap();
        toast.success("Litigation updated successfully!");
      }

      setIsUpdate(false);
      setSelectedLitigation(null);
      setErrors({});
      handleAddLitigationClose();
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
      setErrors(errorMessage);
    }

  };



  // Show modal when delete is clicked
  const handleOpenDeleteModal = (litigationId) => {
    setSelectedLitigationId(litigationId);
    setShowModal(true);
  };

  // Confirm deletion
  const confirmDelete = () => {
    if (selectedLitigationId) {
      dispatch(
        deleteLitigation({
          clientId: client_id,
          data: { lit_id: selectedLitigationId },
        })
      );
    }
    setShowModal(false);
    setSelectedLitigationId(null);
  };

  const handlePagination = (pageNumber) => {
    setCurrentPage(pageNumber);
    dispatch(
      getLitigation({ clientId: client_id, page: pageNumber, perpage: 25 })
    );
  };

  useEffect(() => {
    setCurrentPage(1);
    // if (!hasPermission) {
    //   navigate("/authorization-error");
    // }
    dispatch(
      getLitigation({ clientId: client_id, page: current_page, perpage: 25 })
    );
    return () => dispatch(resetLitigationState());
  }, [dispatch, client_id, hasPermission]);

  return (
    <Base hideDatepicker={true}>
      {/* <Container> */}
      <Row>
        <Col className="mr-auto text-center">
          <Breadcrumb>
            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/clients" }}>
              Clients
            </Breadcrumb.Item>
            <Breadcrumb.Item
              linkAs={NavLink}
              linkProps={{ to: `/clients/tax-forms/${client_id}` }}
            >
              Tax-Forms
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Litigation</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        {/* {(success || error) && (
          <Row className="justify-content-md-center">
            <Col md={3}>
              <Alert
                dismissible
                variant={success ? "success" : "danger"}
                onClose={() => dispatch(resetLitigationState())}
              >
                <p>{success ? successMsg : error}</p>
              </Alert>
            </Col>
          </Row>
        )} */}
        <Col sm={12}>
          <Card className="border-0">
            <CardHeader className="d-flex">
              <Col className="text-end">
                <Button
                  variant="primary"
                  onClick={handleAddLitigationShow}
                  className="fw-bold d-inline-flex align-items-center"
                >
                  <FaPlus className="me-2" /> Add New
                </Button>
              </Col>
              {showAddLitigationModal && (
                <AddLitigation
                  handleSubmit={handleSubmit}
                  fields={LITIGATION_CREATION_FIELDS}
                  errors={errors}
                  show={showAddLitigationModal}
                  onHideFunc={handleAddLitigationClose}
                  values={isUpdate ? selectedLitigation : {}}
                  isUpdate={isUpdate}
                  id={isUpdate ? selectedLitigation.id : 0}
                />
              )}
              {/* <Col sm={6} md={6} className="text-right">
                 <div
                  id="user_list_datatable_info"
                  className="dataTables_filter"
                >
                  <Form.Group className="form-group mb-0">
                    <InputGroup>
                      <Form.Control placeholder="Search" ref={searchRef} />
                      <Button variant="primary">
                        <i className="ri-search-line"></i>
                      </Button>
                    </InputGroup>
                  </Form.Group>
                </div> 
              </Col> */}
            </CardHeader>
            <Tabs
              defaultActiveKey="litigationList"
              id="litigation-management-tabs"
              className="mb-3"
            >
              <Tab eventKey="litigationList" title="Litigation List">
                <CardBody>
                  <Col>
                    <Table responsive className="core-ui-table" >
                      <thead>
                        <tr>
                          <th scope="col">SL.No:</th>
                          <th scope="col">Particulars</th>
                          <th scope="col">Period</th>
                          <th scope="col">Current Status</th>
                          <th scope="col">Final Status</th>
                          <th scope="col">Created At</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {litigationData.length ? (
                          litigationData.map((litigation, index) => (
                            <tr key={litigation.id}>
                              <td>{index + 1}</td>
                              <td>{truncateText(litigation.particular, 16)}</td>
                              <td>{truncateText(litigation.period, 16)}</td>
                              <td>{truncateText(litigation.current_status, 16)}</td>
                              <td>{truncateText(litigation.final_status, 16)}</td>
                              <td>{litigation.created_date.split("T")[0]}</td>
                              <td>
                                <Button
                                  variant="link"
                                  title="Edit Litigation"
                                  onClick={() => {
                                    setSelectedLitigation(litigation);
                                    setIsUpdate(true);
                                    setShowAddLitigationModal(true);
                                  }}
                                >
                                  {/* <i className="ri-pencil-fill"></i> */}
                                  <FaPen />
                                </Button>
                                <Button
                                  variant="link"
                                  className="text-danger"
                                  title="Delete Litigation"
                                  onClick={() =>
                                    handleOpenDeleteModal(litigation.id)
                                  }
                                >
                                  {/* <i className="ri-delete-bin-fill"></i> */}
                                  <FaTrash />
                                </Button>

                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No Litigation Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    <PaginationComponent
                      total_count={total_count}
                      current_page={current_page}
                      handleOnClick={handlePagination}
                      per_page={25}
                    />
                  </Col>
                </CardBody>
              </Tab>
            </Tabs>
          </Card>
        </Col>
      </Row>
      {loading && <Loader />}
      {/* </Container> */}
      <ChatPopup client_id={client_id} chat_type="LITIGATION" />
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this litigation?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

    </Base>
  );
}
